import dayjs from "dayjs";
import { Camera, Dumbbell, Footprints, GlassWater, Salad, Scale, TrendingUp, type LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { MeasurementType, type Measurement } from "@fitness-app/data-models/entities/Measurement";

import MeasurementContent from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeCalendar/components/MeasurementContent";
import { formatLongDay } from "~/components/EventCalendar/calendarModel";
import { EventPopover, EventPopoverCard } from "~/components/EventCalendar/EventPopover";

interface MeasurementCalendarEventProps {
  measurement: Measurement;
}

const ICONS: Record<MeasurementType, LucideIcon> = {
  [MeasurementType.BodyMeasurements]: TrendingUp,
  [MeasurementType.WeightMeasurement]: Scale,
  [MeasurementType.ClientPhoto]: Camera,
  [MeasurementType.HydrationMeasurement]: GlassWater,
  [MeasurementType.HealthStepsMeasurement]: Footprints,
  [MeasurementType.FeedbackAboutNutrition]: Salad,
  [MeasurementType.FeedbackAboutTraining]: Dumbbell,
};

const MeasurementCalendarEvent = ({ measurement }: MeasurementCalendarEventProps) => {
  const { t } = useTranslation(["trainees", "common"]);
  const Icon = ICONS[measurement.type];
  const label = t(`measurementType.${measurement.type}`);

  return (
    <EventPopover
      content={
        <EventPopoverCard
          icon={<Icon />}
          tone="sky"
          title={label}
          subtitle={`${formatLongDay(dayjs(measurement.eventTimestamp))}, ${dayjs(measurement.eventTimestamp).format("HH:mm")}`}
        >
          <MeasurementContent measurement={measurement} />
        </EventPopoverCard>
      }
    >
      <div className="flex min-w-0 items-center gap-x-2">
        <Icon size={14} className="shrink-0" color="rgb(38, 153, 251)" />
        <span className="min-w-0 flex-1 truncate">{label}</span>
      </div>
    </EventPopover>
  );
};

export default MeasurementCalendarEvent;
